import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {ChevronDown} from 'src/components/icons';

const SectionHero = () => {
  const t = useTranslations('franchising');

  const scrollDown = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <div className="tw-relative tw--mt-6">
      <div className="tw-h-[650px] tw-w-full tw-relative">
        <Image
          fill
          style={{objectFit: 'cover'}}
          src={`${IMGPW}/bar_trani.jpeg`}
          alt="Bar image"
        />
      </div>
      <div className="tw-absolute tw-inset-x-0 tw-top-12">
        <div className="container tw-mx-auto">
          <h1 className="tw-text-white tw-py-10 tw-px-3 tw-text-5xl tw-font-bold tw-tracking-tight tw-drop-shadow-lg">
            <span className="tw-bg-black/50 md:tw-leading-[3.5rem] tw-leading-[1.5rem] tw-px-2">
              Eröffnen Sie Ihr eigenes Winelivery Bar-Franchise
              <br />und die Revolution beginnt
            </span>
          </h1>

          <div className="tw-flex tw-flex-col tw-gap-2">
            <button
              className="tw-h-14 tw-w-60 tw-bg-white tw-text-center hover:tw-bg-primary tw-text-primary hover:tw-text-white tw-border tw-border-primary hover:tw-border-white tw-py-2 tw-rounded-full focus:tw-outline-none tw-transition-colors tw-duration-200 tw-text-xl tw-font-bold tw-shadow-lg"
              onClick={() => scrollDown('affiliazione')}
            >
              Kontaktiere uns
            </button>
          </div>
        </div>
      </div>
      <div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-hidden md:tw-block">
        <ChevronDown
          className="tw-h-12 tw-w-12 tw-text-white tw-animate-bounce tw-mx-auto tw-mb-6 md:tw-mb-0 tw-cursor-pointer"
          onClick={() => scrollDown('apri')}
        />
      </div>
    </div>
  );
};

export default SectionHero;
